import React from 'react';
import {Stack} from '@mui/material';
import {
  designSystemToken,
  Icon,
  Label,
  IconName,
} from '@lightricks/react-design-system';
import translate from '@/utils/translate';

function FeaturePageNavItem({
  icon,
  label,
  isActive,
  disabled = false,
  backgroundColor,
  buttonSize = '90px',
  labelSize = 'md',
  borderRadius = '8px',
  gap = '10px',
}: {
  icon: IconName;
  label: string;
  isActive: boolean;
  disabled?: boolean;
  backgroundColor?: string;
  buttonSize?: string;
  labelSize?: 'lg' | 'md' | 'sm' | 'xs';
  borderRadius?: string;
  gap?: string;
}) {
  let currentBackgroundColor = backgroundColor;
  if (isActive && !backgroundColor) {
    currentBackgroundColor = designSystemToken('semantic.bg.inverse');
  } else if (!backgroundColor) {
    currentBackgroundColor = designSystemToken('semantic.bg.secondary');
  }

  let iconColor;
  if (disabled) {
    iconColor = designSystemToken('semantic.fg.disabled');
  } else if (isActive) {
    iconColor = designSystemToken('semantic.fg.inverse');
  } else {
    iconColor = designSystemToken('semantic.fg.primary');
  }

  let labelColor;
  if (disabled) {
    labelColor = designSystemToken('semantic.fg.disabled');
  } else if (isActive) {
    labelColor = designSystemToken('semantic.fg.inverse');
  } else {
    labelColor = designSystemToken('semantic.fg.primary');
  }

  return (
    <Stack
      direction="column"
      alignItems="center"
      justifyContent="center"
      gap={gap}
      width={buttonSize}
      height={buttonSize}
      sx={{
        cursor: disabled ? 'not-allowed' : 'pointer',
        backgroundColor: currentBackgroundColor,
        opacity: disabled ? 0.5 : 1,
      }}
      borderRadius={borderRadius}
    >
      <Icon
        name={icon}
        size="large"
        appearance={disabled ? 'secondary' : 'primary'}
        color={iconColor}
      />
      <Label size={labelSize} color={labelColor}>
        {translate(label)}
      </Label>
    </Stack>
  );
}

export default FeaturePageNavItem;
